import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import IconButton from '@mui/material/IconButton'
import { Button, CircularProgress, useMediaQuery } from '@mui/material'
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded'
import LogoutIcon from '@mui/icons-material/Logout'
import { HelpOutlinedIcon, LogoPrimaryIcon } from '../../../assets/icons/icons'
import HeaderHcsSwitch from './HeaderHcsSwitch'
import HeaderUserMenu from './HeaderUserMenu'
import useStyles from './_styles'
import HeaderNavigation from './HeaderNavigation'
import HeaderNavigationPopover from './HeaderNavigationPopover'
import useLogout from '../../../hooks/useLogout'
import useCurrentHcs from '../../../hooks/useCurrentHcs'
import PlannedExpertiseAbandonDialog from '../../Teleexpertise/plannedExpertiseEditor/PlannedExpertiseAbandonDialog'
import { useHelpCenterDialogContext } from '../../../context/HelpCenterDialogContext'
import { HelpCenter } from '@workspace/frontend-kit'

const Header = ({ tunnelMode }: { tunnelMode?: boolean }) => {
    const classes = useStyles()
    const [isOpen, setIsOpen] = React.useState(false)
    const [isAbandonDialogOpen, setIsCancelDialogOpen] = React.useState(false)
    const navigate = useNavigate()
    const isPhone = useMediaQuery((theme: any) => theme.breakpoints.down('sm'))
    const { logout, loading } = useLogout()
    const { isCurrentUserCertified } = useCurrentHcs()
    const { isHelpOpen, openHelp, closeHelp } = useHelpCenterDialogContext()

    const handleClick = () => setIsOpen(!isOpen)
    const showNavigation = !tunnelMode && isCurrentUserCertified
    const showNormalMode = !tunnelMode

    const handleCancelClick = () => {
        setIsCancelDialogOpen(true)
    }

    const handleCancelConfirm = () => {
        navigate('/teleexpertises')
    }

    return (
        <>
            <div className={classes.Header} data-cy="app_header">
                <div className={classes.HeaderLeft} style={tunnelMode ? { gap: 0 } : undefined}>
                    <div className={classes.HeaderLogo}>
                        {tunnelMode ? (
                            <div className={classes.HeaderTitle}>Initier une demande de téléexpertise</div>
                        ) : (
                            <>
                                <LogoPrimaryIcon width="1.6rem" />
                                <Link to="/" className={classes.HeaderAppName}>
                                    Espace TokTokDoc
                                </Link>
                            </>
                        )}
                    </div>
                    {showNavigation && <HeaderNavigation />}
                    {showNavigation && <HeaderNavigationPopover />}
                </div>

                <div className={classes.HeaderRight}>
                    <IconButton onClick={openHelp}>
                        <HelpOutlinedIcon className={classes.HeaderRightHelpButton} />
                    </IconButton>
                    {tunnelMode && (
                        <>
                            <Button className={classes.HeaderInitTeleexpertiseButton} onClick={handleCancelClick}>
                                {isPhone ? <DeleteRoundedIcon /> : 'Abandonner'}
                            </Button>
                            <PlannedExpertiseAbandonDialog
                                isOpen={isAbandonDialogOpen}
                                onClose={() => setIsCancelDialogOpen(false)}
                                onConfirm={handleCancelConfirm}
                            />
                        </>
                    )}

                    {showNormalMode && (
                        <>
                            <HeaderHcsSwitch />
                            {isCurrentUserCertified ? (
                                <HeaderUserMenu />
                            ) : (
                                <Button
                                    startIcon={loading ? <CircularProgress size={20} /> : <LogoutIcon />}
                                    disabled={loading}
                                    className={classes.HeaderLogOutButton}
                                    onClick={logout}
                                >
                                    Se déconnecter
                                </Button>
                            )}
                        </>
                    )}
                </div>
            </div>
            <HelpCenter open={isHelpOpen} onClose={closeHelp} />
        </>
    )
}

export default Header
